import React from 'react';
import resources from '../../../services';
import DataTable from '../../../composents/DataTable';
import MainPage from '../../../composents/MainPage';

const title = 'Clients';
const headers = {
	icon: 'feather icon-users',
	title: title,
	description: 'track and manage all clients information',
};

function CustomerPage() {
	return (
		<MainPage headers={headers} show_search>
			<DataTable
				column={[
					{
						label: 'Client Name',
						field: 'name',
					},
					{
						label: 'Client ID',
						field: 'HWC_ID',
					},

					{
						label: 'Client code',
						field: 'code_2',
					},
					{ label: 'Email', field: 'email' },
					{
						label: 'City',
						field: 'city',
						renderStyle: (el) => el?.city?.name,
					},
					{
						label: 'HD Entity',
						field: 'HDEntity',
						renderStyle: (el) => el?.HDEntity?.name,
					},
				]}
				resource={resources.customer}
				title={title}
				link="/clients/clients"
			/>
		</MainPage>
	);
}

export default CustomerPage;
